// Forma yuborishning YAGONA joyi — antd `validateFields()` ning rad
// javobi shu yerda, BIR marta ishlanadi.
//
// =====================================================================
// ⛔ NIMA UCHUN BU FAYL BOR (N6, 2026-08-15)
// =====================================================================
// Regressiya supurgichi 32 ta dialogning HAMMASIDA bir xil ushlanmagan
// xato o'lchagan — har muvaffaqiyatsiz forma validatsiyasida:
//
//     pageerror: {"stack":"","message":"Object","log":[],"name":""}
//
// Sabab bitta va u 50 joyga NUSXALANGAN edi:
//
//     void form.validateFields().then((values) => save.mutate(values))
//          ^^^^
//
// `void` — bu «natijani tashla» degani, «xatoni ushla» degani EMAS.
// antd forma yaroqsiz bo'lsa promise'ni `{ values, errorFields,
// outOfDate }` obyekti bilan RAD ETADI. Uni hech kim ushlamagani uchun
// brauzer `unhandledrejection` beradi.
//
// ⚠️ Nima uchun bu «ko'rinmasa ham muhim»: foydalanuvchi hech narsa
// sezmaydi (maydon xatolari o'z joyida chiqadi), lekin ishlab
// chiqarish konsoli har «Saqlash» bosilganda axlat bilan to'ladi va
// HAQIQIY xato o'sha axlat ichida ko'rinmay qoladi. Supurgich aynan
// shu sababli 32 ta yolg'on signal berdi.
//
// =====================================================================
// ⚠️ NEGA `.catch()` EMAS — bu eng muhim tafsilot
// =====================================================================
// `.then(handler).catch(...)` yozilsa, `handler` NING O'ZI tashlagan
// xato ham o'sha `catch` ga tushardi — ya'ni saqlash mantiqidagi
// haqiqiy nosozlik JIMGINA yutilardi. Bu nuqsonni tuzatish emas,
// KATTALASHTIRISH bo'lardi.
//
// Shuning uchun `then(onFulfilled, onRejected)` ning IKKI ARGUMENTLI
// shakli ishlatiladi: rad javobini ishlovchi FAQAT
// `validateFields()` ning o'zidan kelgan radga qo'llanadi.
// `handler` tashlagan xato esa oldingidek yuqoriga chiqadi.
//
// ⚠️ Va tanilmagan rad javobi QAYTA TASHLANADI. Agar antd bir kuni
// boshqa shaklda rad etsa, biz buni JIM YUTMAYMIZ — konsolda
// ko'ramiz. «Hammasini yut» degan qorovul nuqsonni yashirardi.
import type { FormInstance } from 'antd'

/**
 * Rad javobi antd validatsiyasidanmi?
 *
 * antd `rejectPromise({ values, errorFields, outOfDate })` qiladi
 * (`rc-field-form/lib/useForm`). Shakl AYNAN tekshiriladi: `Error`,
 * tarmoq nosozligi va boshqa har qanday obyekt bu tekshiruvdan
 * O'TMASLIGI kerak.
 *
 * ⚠️ ALOHIDA EKSPORT — `tests/form-rejection.mjs` aynan shu funksiyani
 * chaqiradi, ya'ni sinov mantiqning NUSXASI ustida emas, jonli kod
 * ustida yuradi.
 */
export function isFormValidationRejection(reason: unknown): boolean {
  if (typeof reason !== 'object' || reason === null) return false
  const candidate = reason as { errorFields?: unknown; outOfDate?: unknown }
  return Array.isArray(candidate.errorFields) && typeof candidate.outOfDate === 'boolean'
}

/**
 * Forma yaroqli bo'lsa `handler` ni chaqiradi; yaroqsiz bo'lsa JIM
 * to'xtaydi — maydon xatolari antd tomonidan ekranda ko'rsatiladi.
 *
 * ⚠️ Bu funksiya `void form.validateFields().then(...)` naqshining
 * O'RNIGA yoziladi. Xom naqshni `tests/form-rejection.mjs` BUILD
 * paytida taqiqlaydi — aks holda yangi dialog yana adashardi.
 */
export function submitOnValid<Values>(
  form: FormInstance<Values>,
  handler: (values: Values) => unknown,
): void {
  void form.validateFields().then(handler, (reason: unknown) => {
    if (isFormValidationRejection(reason)) return
    throw reason
  })
}
